import { render, staticRenderFns } from "./SigninCallback.vue?vue&type=template&id=976a1780&"
import script from "./SigninCallback.vue?vue&type=script&lang=js&"
export * from "./SigninCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports